
const cookieExpiration = '10h';

function storeData(app, redirectURL, redirectView, returnURL, returnView) {
	// este es el objeto que quiero almacenar
	let obj = {
		toUrl: redirectURL,
		toView: redirectView,
		returnToUrl: returnURL,
		returnToView: returnView
	};

	let b = Buffer.from(JSON.stringify(obj));
	app.$cookie.set(
		'cross_site_redirect', 
		b.toString('base64'), 
		{ expires: cookieExpiration }
	);   

	return obj;
}

function getData(app) {
	let cookie = app.$cookie.get('cross_site_redirect');
	if( cookie ) {
		try {
			return JSON.parse(
				Buffer.from(cookie,'base64')
			);
		} catch {
			return {};
		}
	}
	return {};
}

const redirect = function(app, redirectURL, redirectView, returnURL, returnView){	
	storeData(app, redirectURL, redirectView, returnURL, returnView);
	window.location.replace(redirectURL);
}

const load = function(app){
	app.$root.__cross_site_redirect = getData(app);
	app.$cookie.delete('cross_site_redirect');
	return app.$root.__cross_site_redirect;
}

const tryReturn = function(app, callback){
	if(app.$root.__cross_site_redirect) {
		let returnUrl = app.$root.__cross_site_redirect.returnToUrl || '';
		let returnView = app.$root.__cross_site_redirect.returnToView || '';
		if(returnUrl) {
			storeData(app, returnUrl, returnView, '', '');
			window.location.replace(returnUrl);
			return;
		}
	}
	if( callback ) {
		callback.call(app);
	}
}

const goBack = function(app) {
	if( app.$router.history.index == 0 ) {
		// estoy en la primer página a la que se navegó, así que ya no se puede ir más para atrás
		// intento devolver a la url desde la que se vino
		tryReturn(app);
		return;
	}
	try {
		app.$router.go(-1);
	} catch(e) {
		console.warn('router go back error',e)
	}
}

const redirectToView = function(app){
	let toView = app.$root.__cross_site_redirect.toView || '';
	app.$root.__cross_site_redirect.toView = "";			// el redirect solo debe ser hecho una vez
	if(toView) {
		app.$router.push(toView);
		return true;
	}
	return false;
}

export default {redirect, load, tryReturn, redirectToView, goBack}
